import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import _ from 'lodash';
import moment from 'moment';

/** Pipe for times */
@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {
  /** constructor */
  constructor(private _translateSrv: TranslateService) { }

  /**
   * Returns time string formatted
   * @example {{myTime | time:true:false}}
   */
  transform(value:	string | number | Date, seconds?: boolean, withoutHourTag?: boolean): string {
    const key = seconds ? 'TimeAndSeconds' : 'Time';
    const hourTag = withoutHourTag ? '' : 'h';
    const format = this._translateSrv.instant(`DateFormat.Moment.${key}`);
    const empty = this._translateSrv.instant(`DateFormat.Empty.${key}`);

    return (!_.isNil(value) ? moment(value).format(format) : empty) + hourTag;
  }

}
